// 🔴 2026-07-17 v3.6.60: 独立模块避免 AgentChatPage 顶层 mermaid.initialize 跨 chunk TDZ
// 用法：import { initMermaidOnce } from '@/lib/mermaid'; initMermaidOnce();
import mermaid from 'mermaid';

let initialized = false;

export function initMermaidOnce() {
  if (initialized) return;
  initialized = true;
  try {
    mermaid.initialize({
      startOnLoad: false,
      theme: 'dark',
      securityLevel: 'sandbox',
    });
  } catch (e) {
    // 二次调用 initialize 会抛错，但首次成功就不管
    console.warn('[mermaid] initialize skipped:', e);
  }
}

export { mermaid };
